<template>
  <div class="page-template add-page order-add-page" v-loading="loading">
    <div class="page-title">{{ title }}</div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="audit(3)" type="primary" plain :disabled="formModel.reviewerStatus === null">审核</el-button>
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form v-show="complexShow" ref="listOperationForm" :formOptions="listFormOptions"
                         @valueChange="listFormValueChange"></list-operation-form>
    <div class="search-goods-box">
      <el-input id="goodsText"
                placeholder="条码/自编码/助记码"
                v-model="goodsTxt"
                class="search-goods-input"
                @change="search"
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <!--<div class="el-icon-search more-btn" @click="search"></div>-->
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button @click="checkGoods" type="primary" plain class="select-good">选择商品</el-button>
      <!--<el-button @click="downloadTemplate" type="primary" plain>下载模板</el-button>-->
      <!--<el-button @click="importData" type="primary" plain>导入商品</el-button>-->
      <el-button @click="openImport" type="primary" plain>导入商品</el-button>
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog title="商品列表" :visible.sync="listShow" width="1200px" height="800"
               :close-on-click-modal="false">
      <good-list
        v-if="listShow"
        ref="goodsListOperation"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :tableOptions="tableOptions"
        :otherParam="otherParam"
        @selectSubmit="rowsSelectSubmit"
        :selectUrl="selectUrl"
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="importShow" custom-class="importDialog" :close-on-click-modal="false">
      <import-template v-if="importShow" ref="importTemplate" :importShow="importShow"
                       @importFile="importData" @downTemplate="downloadTemplate"></import-template>
    </el-dialog>
  </div>
</template>
<script>
// 商品列表组件
import goodList from '@/components/business/goodList';
// 添加要货单组件
import listOperationNew from "@/components/template/listOperationNew";
// 要货单搜索组件
import listOperationForm from '@/components/template/listOperationForm';
import api from '@/config/api';
import userPower from '@/mixin/userPower'
// 导入模版组件
import importTemplate from '@/components/business/importTemplate';

export default {
  mixins: [userPower],
  components: {
    listOperationNew,
    goodList,
    listOperationForm,
    importTemplate
  },
  data() {
    return {
      copyParams:{},
      importShow: false,
      isCheck: false,
      complexShow: true,
      goodsTxt: "",
      listTableData: [], // 用于传给选择商品组件，判断是否已被选择
      goodListSelect: false,
      formModel: {reviewerStatus: null},
      loading: false,
      title: '',
      listShow: false,
      goodList: [],
      dialogShow: false,
      isSelectWarehouse: true,
      isClearTableData: true,
      selectUrl: {url: api.warehouse.warehouseGoods},
      otherParam: {statusList: [10, 30]},
      // 头部条件
      listFormOptions: {
        disabled: false,
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          }
        },
        labelWidth: '130px',
        columns: [
          {
            prop: 'id',
            hidden: true
          },
          {
            prop: 'relateId',
            hidden: true
          },
          {
            label: '业务单号',
            type: 'input',
            prop: 'orderNo',
            span: 12,
            disabled: true
          },
          {
            label: '批发门店',
            type: 'storeInputDialog',
            prop: 'storeId',
            isHasAll: true,
            disabled: false,
            //change: this.storeChange,
            span: 12
          },
          {
            label: '仓库',
            type: 'warehouseInputDialog',
            prop: 'warehouseId',
            disabled: false,
            data: [],
            //change: this.warehouseChange,
            span: 12

          },
          {
            label: '批发客户',
            type: 'wholesaleCustomerInputDialog',
            prop: 'wholesaleCustomerId',
            disabled: false,
            span: 12,
            //change: this.storeChange,
            isEditedCustomer: false
          },
          {
            label: '批发销售单',
            type: 'orderDialog',
            prop: 'wholesaleOrderNo',
            labelKey: 'orderNo',
            uniqueKey: 'orderNo',
            span: 12,
            url: api.wholesale.wholesaleOrders,
            columns: [
              {label: "单号", prop: "orderNo", align: "center"},
              {label: "金额", prop: "totalAmt", align: "center"},
              {label: "数量", prop: "wholesaleNum", align: "center"}
            ]
          },
          {
            label: '经手人',
            prop: 'salesman',
            type: 'input',
            maxLength: 16,
            span: 12
          }, {
            label: '备注',
            type: 'input',
            maxLength: 16,
            prop: 'remarks',
            span: 12
          }]
      },
      goodsCopyList: [],
      // 添加表格字段
      listColumns: {
        disabled: false,
        summaryColumns: ['goodsCount', 'beforeAmt', 'discountAmt'],
        columns: [
          {label: '操作', type: 'operation', width: 100, prop: 'operation'},
          {label: '序号', type: 'index', width: 60, prop: 'idx'},
          {
            label: '条码',
            prop: 'barCode',
            // type: 'input',
            width: '150',
          },
          {
            label: '商品名称',
            prop: 'name',
            width: '90'
          },
          {
            label: '自编码',
            width: '90',
            prop: 'artNo'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '60'
          },
          {
            label: '单位',
            width: '60',
            prop: 'unitName'
          },
          {
            label: '数量',
            width: '110',
            prop: 'goodsCount',
            type: 'inputNumber',
            change: this.numChange,
            max: 9999.999,
            min: 0,
            precision: 3
          },
          {
            label: '赠送数量',
            width: '90',
            prop: 'giveGoodsCount',
            type: 'inputNumber',
            change: this.giveGoodsCountChange,
            max: 9999.999,
            min: 0,
            precision: 3
          },
          {
            label: '单价',
            width: '110',
            prop: 'discountPrince',
            type: 'inputNumber',
            max: 99999.99,
            change: this.discountPrinceChange,
            precision: 2
          },
          {
            label: '折扣率',
            width: '90',
            prop: 'discountRate',
            type: 'inputNumber',
            change: this.rateChange,
            precision: 2
          },
          {
            label: '小计金额',
            width: '130',
            prop: 'discountAmt',
            type: 'inputNumber',
            disabled: true,
            precision: 2
          },
          {
            label: '系统库存',
            width: '90',
            prop: 'inventoryNum'
          },
          {
            label: '原价',
            width: '90',
            prop: 'tradePrice'
          },
          {
            label: '原价金额',
            width: '90',
            prop: 'beforeAmt'
          },
          {
            label: '备注',
            prop: 'remarks',
            maxLength: 16,
            type: 'input',
            width: '200'
          },

        ],
        url: api.delivery.requisition
      },
      // 表格信息配置
      tableOptions: {
        indexShow: true, // 是否显示索引
        indexMethod: (index) => { // 自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '条码',
            prop: 'barCode',
            width: '200',
            align: 'center'
          },
          {
            label: '品名',
            prop: 'goodsName',
            width: '100',
            align: 'center'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '100',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '200',
            align: 'center'
          },
          {
            label: '原价',
            width: '90',
            prop: 'tradePrice'
          },
          {
            label: '库存',
            prop: 'inventoryNum',
            width: '150',
            align: 'center'
          }
        ],
        param: this.otherParam,
        url: api.archives.goodsInfoIncludeSpecs
      },
      checkIndex: ''
    }
  },
  created() {
    this.title = (this.$route.query.id ? '编辑' : '新增') + document.title;
    if (this.$route.query.id) {
      this.getDetail();
    }else {
      {
        this.$nextTick(() => {
          this.$refs.listOperationForm.formModel.warehouseId = this.$utils.getSysUser().warehouseId;
          this.isSelectWarehouse = false;
          this.copyParams.warehouseId = this.$utils.getSysUser().warehouseId;
          this.listFormOptions.columns.filter(item => item.prop === "wholesaleOrderNo")[0].params = this.copyParams;
        })
      }
    }
    this.setStoreId(this.listFormOptions.columns);
  },
  methods: {
    //点击 高级搜索显示
    complexFunc() {
      if (!this.isCheck) {
        this.complexShow = !this.complexShow;
      }
    },
    listFormValueChange(value, column) {
      if (column.prop === "storeId") {
        this.$refs['listOperation'].clearTableData();
        this.otherParam.storeId = value.id;
        this.listFormOptions.columns.filter(
          item => item.prop === "warehouseId"
        )[0].params = {storeId: value.id};
        this.listFormOptions.columns.filter(
          item => item.prop === "wholesaleCustomerId"
        )[0].params = {storeId: value.id};


        //切换门店清空数据
        this.$refs.listOperationForm.$refs.wholesaleCustomerInputDialog[0].initData();
        // this.$refs.listOperationForm.$refs.warehouseInputDialog[0].initData();
        this.$refs.listOperationForm.$refs.orderDialog[0].initData();
        this.$refs.listOperationForm.formModel.wholesaleCustomerId = "";
        this.$refs.listOperationForm.formModel.wholesaleOrderNo = "";
        this.$refs.listOperationForm.formModel.storeId = value.id;
        if (value.warehouseId){
          this.$refs.listOperationForm.formModel.warehouseId = value.warehouseId;
          this.otherParam.warehouseId = value.warehouseId;
          this.isSelectWarehouse = false;
          this.copyParams.warehouseId=value.warehouseId;
        }
        this.listFormOptions.columns.filter(
          item => item.prop === "wholesaleOrderNo"
        )[0].params = {storeId: value.id};
      }
      if (column.prop === "wholesaleCustomerId") {
        this.otherParam.wholesaleCustomerId = value;
        this.copyParams.wholesaleCustomerId = value;
        this.listFormOptions.columns.filter(item => item.prop === "wholesaleOrderNo")[0].params = this.copyParams;
        this.$refs.listOperationForm.$refs.orderDialog[0].initData();
        this.$refs.listOperationForm.formModel.wholesaleOrderNo = "";
        this.$refs['listOperation'].clearTableData();
      }
      if (column.prop === "warehouseId") {
        this.otherParam.warehouseId = value;
        this.isSelectWarehouse = false;
        this.copyParams.warehouseId=value;
        this.listFormOptions.columns.filter(item => item.prop === "wholesaleOrderNo")[0].params = this.copyParams;
        this.$refs.listOperationForm.$refs.orderDialog[0].initData();
        this.$refs.listOperationForm.formModel.wholesaleOrderNo = "";
      }
      if (column.prop === "wholesaleOrderNo"){
        this.wholesaleOrderNoChange(value);
      }
    },

    getDetail() {
      this.loading = true;
      this.$axios
        .fetchGet(api.wholesale.wholesaleReturn + '?id=' + this.$route.query.id, {})
        .then(data => {
          this.formModel = data.data;
          this.loading = false;
          if (data.code === 200) {
            this.goodsCopyList = data.data.wlWholesaleOrderGoodsMapList;
            this.$nextTick(() => {
              // 为头部表单赋值
              this.$refs.listOperationForm.formModel = data.data;
              data.data.wlWholesaleOrderGoodsMapList.map(item => {
                item.tradePrice = item.beforePrince;
                item.name = item.goodsName;
              });// 审核的时候需要对数量进行校验
              this.goodsCopyList = this.$utils.deepClone(data.data.wlWholesaleOrderGoodsMapList);
              this.goodsCopyList.map(item => {
                item.goodsCount = item.goodsCount + item.remainingNum;
              });
              this.isSelectWarehouse = false;
              this.isClearTableData = false;
              this.listFormOptions.columns.filter(item => item.prop === 'wholesaleCustomerId')[0].isEditedCustomer = true;
              // 为表格赋值
              this.$refs['listOperation'].addMoreRow(data.data.wlWholesaleOrderGoodsMapList, 0);
              this.currentTableList = this.$refs['listOperation'].getTabelData();
              this.listFormOptions.columns.filter(item => item.prop === 'wholesaleCustomerId')[0].disabled = true;
              this.listFormOptions.columns.filter(item => item.prop === 'warehouseId')[0].disabled = true;
              this.listFormOptions.columns.filter(item => item.prop === 'salesman')[0].disabled = true;
              this.listFormOptions.columns.filter(item => item.prop === 'wholesaleOrderNo')[0].disabled = true;
              this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
            });
          } else {
            this.$message({message: data.msg, type: 'error'});
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        });
    },
    search() {
      if (this.goodsTxt === '' || this.goodsTxt === null) return;
      this.otherParam.otherName = this.goodsTxt;
      if (this.isSelectWarehouse) {
        this.goodsTxt = '';
        this.$confirm("请选择仓库！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
      } else {
        this.isCheck = true;
        this.$axios
          .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
          .then(res => {
            if (res.code === 200) {
              if (res.data.length > 0) {
                let tableData = res.data;
                if (tableData.length === 1) {
                  let row = tableData[0];
                  let tableList = this.$refs["listOperation"].getTabelData();
                  let flag = true;
                  if (tableList.length > 0) {
                    tableList.forEach(item => {
                      if (flag) {
                        if (item.barCode === row.barCode) flag = false;
                      }
                    });
                  }
                  if (!flag) {
                    this.$message.warning("[名称:" + row.goodsName + ",条码:" + row.barCode + "],已存在！！！");
                    return;
                  }
                  row.name = row.goodsName;
                  row.goodsCount = 0.00.toFixed(3);// 数量
                  row.giveGoodsCount = 0.00.toFixed(3);// 赠送数量
                  row.beforeAmt = 0.00.toFixed(2);// 原金额
                  row.discountRate = 1.00.toFixed(2);// 折扣
                  row.discountPrince = row.tradePrice;// 折扣价
                  row.discountAmt = 0.00.toFixed(2);// 小计金额
                  row.isFinalNum = true;
                  // this.$refs["listOperation"].addMoreRow(row, tableList.length);
                  this.$refs["listOperation"].setColumnData(row, tableList.length);
                  this.currentTableList = this.$refs["listOperation"].getTabelData();
                  this.$message.success("商品添加成功");
                } else {
                  this.queryGoodsList();
                }
              } else {
                this.$message.warning("[条码:" + this.goodsTxt + "],商品不存在！！！");
              }
            } else {
              this.$message({type: "error", message: res.msg});
            }
          })
          .catch(err => {
          }).finally(() => {
          this.isCheck = false;
          this.clearQueryParam();
        });
      }
    },
    clearQueryParam() {
      this.goodsTxt = '';
      this.otherParam.otherName = '';
    },
    checkGoods() {
      if (!this.isCheck) {
        if (this.isSelectWarehouse) {
          this.$confirm('请选择仓库！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
        } else {
          this.queryGoodsList();
        }
      }
    },
    queryGoodsList() {
      this.listShow = true;
      this.goodListSelect = true;
      this.listTableData = this.$refs['listOperation'].getTabelData()// table数据
    },
    rowsSelectSubmit(rows) {
      // 商品多选的时候进行相应数据初始化
      rows.map(item => {
        console.log(item.tradePrice);
        item.name = item.goodsName;
        item.goodsCount = 0.00.toFixed(3);// 数量
        item.giveGoodsCount = 0.00.toFixed(3);// 赠送数量
        item.beforeAmt = 0.00.toFixed(2);// 原金额
        item.discountRate = 1.00.toFixed(2);// 折扣
        item.discountPrince = item.tradePrice;// 折扣价
        item.discountAmt = 0.00.toFixed(2);// 小计金额
        item.isFinalNum = true;
      });
      this.listShow = false;
      let tableList = this.$refs['listOperation'].getTabelData();
      this.$refs['listOperation'].addMoreRow(rows, tableList.length);
      this.currentTableList = this.$refs['listOperation'].getTabelData();
      if (rows && rows.length > 0) {
        this.$message.success("商品添加成功");
      }
    },
    numChange(row, index) {
      let rowData = this.$utils.deepClone(this.currentTableList[index]);
      if (row.goodsCount === '' || row.goodsCount == null) {
        row.goodsCount = rowData.goodsCount.toString();
        return;
      }
      if (this.goodsCopyList.length !== 0) {
        this.goodsCopyList.map(item => {
          if (item.barCode === row.barCode) {
            if (row.goodsCount > item.goodsCount) {
              this.$confirm(row.name + '：实际批发销售的剩余数量为' + item.goodsCount + '多余部分请重新制定入库单！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                row.finalNum = 1;
                row.goodsCount = item.goodsCount;
                this.updateData(row, index);
              }).catch(() => {
                row.finalNum = 1;
                row.goodsCount = item.goodsCount;
                this.updateData(row, index);
              })
            } else if (row.goodsCount < item.goodsCount) {
              // 后端通过这个判断是否是部分退货
              row.remainingNum = item.goodsCount - row.goodsCount;
              row.finalNum = 0;
              this.updateData(row, index);
            }
          }
        });
        row.finalNum = 1;
        this.updateData(row, index);
      } else {
        row.finalNum = 1;
        this.updateData(row, index);
      }
    },
    updateData(row, index) {
      if (row.tradePrice) {
        row.discountAmt = row.beforeAmt = parseFloat(row.discountPrince * row.goodsCount).toFixed(2);
      }
      this.$refs['listOperation'].setCountData(row, index);
    },

    rateChange(row, index) {
      let rowData = this.$utils.deepClone(this.currentTableList[index]);
      if (row.discountRate === '' || row.discountRate == null) {
        row.discountRate = rowData.discountRate.toString();
        return;
      }
      if (row.discountRate) {
        row.discountPrince = parseFloat(row.tradePrice * row.discountRate).toFixed(2);
        row.discountAmt = parseFloat(row.discountPrince * row.goodsCount).toFixed(2);
      }
      this.$refs['listOperation'].setCountData(row, index);
    },
    // 返回按钮事件
    beBack() {
      if (!this.isCheck) {
        this.$router.go(-1);
      }
    },
    refresh() {
      if (!this.isCheck) {
        this.$router.go(0);
      }
    },
    // 审核
    audit(e) {
      if (!this.isCheck) {
        this.submitAuth(e);
      }
    },
    // 选择某行数据
    rowCheck(row) {
      row.name = row.goodsName;
      row.goodsCount = 0.00.toFixed(3);// 数量
      row.giveGoodsCount = 0.00.toFixed(3);// 赠送数量
      row.beforeAmt = 0.00.toFixed(2);// 原金额
      row.discountRate = 1.00.toFixed(2);// 折扣
      row.discountPrince = row.tradePrice;// 折扣价
      row.discountAmt = 0.00.toFixed(2);// 小计金额
      row.isFinalNum = true;
      this.listShow = false;
      this.$refs['listOperation'].setColumnData(row, this.checkIndex);
      this.currentTableList = this.$refs['listOperation'].getTabelData();
    },
    validePirce(val) {
      const priceArray = ['buyPrice', 'deliveryPrice', 'lowestPrice', 'plusVipPrice', 'retailPrice', 'tradePrice', 'vipPrice'];
      if (priceArray.includes(val)) {
        return true
      } else {
        return false
      }
    },
    valideMount(val) {
      const mountArray = ['goodsCount', 'giveGoodsCount'];
      if (mountArray.includes(val)) {
        return true
      } else {
        return false
      }
    },
    // 提交数据
    submitAuth(e) {
      if (!this.isCheck) {
        // 将表头的值重新赋值给后端接收的参数
        let headParam = this.$refs.listOperationForm.getFormModel();
        headParam.reviewerStatus = 20;
        // 将商品list的值重新赋值给后端接收的参数
        let tableList = this.$refs.listOperation.getTabelData();
        let orderNumber = 1;
        tableList.map(item => {
          item.orderNumber = orderNumber++;
          item.wholesaleType = 60;
        });
        tableList.map(item => {
          item.goodsId = item.goodsId || item.id;
          item.beforePrince = item.tradePrice;
        });
        // 将合计的值重新赋值给后端接收的参数
        let totalParam = this.$refs.listOperation.getSumData();
        totalParam.totalAmt = totalParam.discountAmt;
        totalParam.wholesaleNum = totalParam.goodsCount;
        let searchParam = {
          ...{wlWholesaleOrderGoodsMapList: tableList}, ...totalParam, ...headParam
        };
        if (headParam.warehouseId === undefined) {
          this.$confirm('请选择仓库！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
        } else if (!headParam.wholesaleCustomerId) {
          this.$confirm('请选择批发客户！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
        } else if (tableList.length === 0) {
          this.$message({message: '商品信息无效！', type: 'warning'});
        } else {
          let priceFlag = false
          let mountFlag = false
          tableList.map(item => {
            for (let key in item) {
              if (this.validePirce(key)) {
                if (item[key] > 99999.99) {
                  priceFlag = true
                }
              }
              if (this.valideMount(key)) {
                if (item[key] > 9999.999) {
                  mountFlag = true
                }
              }
            }
          })
          if (mountFlag) return this.$message.warning('数量相关不能超过9999.999')
          if (priceFlag) return this.$message.warning('价格不能超过99999.99')
          let testSave = false
          testSave = tableList.every(v => {
            if (v.goodsName) {
              return true
            } else {
              return false
            }
          })
          if (testSave) {
            tableList.map(table => {
              // if (table.goodsCount === 0) {
              if ((table.goodsCount + table.giveGoodsCount) < 0 || (table.goodsCount + table.giveGoodsCount) == 0) {
                this.$confirm('存在数量为0.00的商品，是否继续操作?', '提示',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }
                ).then(() => {
                  this.saveData(headParam, e, searchParam);
                }).catch(() => {
                })
              } else {
                this.saveData(headParam, e, searchParam);
              }
            });
          }
        }
      }
    },

    saveData(headParam, e, searchParam) {
      if (headParam.id) {
        if (e === 3) {
          this.$confirm('是否确认审核?', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
            this.handleRequest(this.$axios
              .fetchPost(api.wholesale.wholesaleReturn + '/audit', searchParam), e);
          }).catch(() => this.$message({message: '审核取消！', type: 'info'}));
        } else {
          this.$confirm('是否确认保存?', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
            this.handleRequest(this.$axios
              .fetchPut(api.wholesale.wholesaleReturn, searchParam), e);
          }).catch(() => this.$message({message: '保存取消！', type: 'info'}));
        }
      } else {
        this.$confirm('是否确认保存?', '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          this.handleRequest(this.$axios
            .fetchPost(api.wholesale.wholesaleReturn, searchParam), e);
        }).catch(() => this.$message({message: '保存取消！', type: 'info'}));
      }
    },
    // 处理添加和编辑的请求
    handleRequest(parm, e) {
      const loading = this.$loading({
        lock: true,
        text: '提交中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      parm.then(data => {
        this.loading = false;
        if (data.code === 200) {
          if (e === 3) {
            this.$notify({
              type: "success",
              title: '审核操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '审核成功！', type: 'success'});
            this.$router.push({path: '/wholeasle/return'});
          } else {
            this.$notify({
              type: "success",
              title: '保存操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '保存成功！', type: 'success'});
            this.dialogShow = false;
            this.$refs.listOperationForm.formModel = data.data;
            this.formModel.reviewerStatus = data.data.reviewerStatus;
          }
        } else {
          if (e === 3) {
            this.$notify({
              type: "error",
              title: '审核操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: '审核失败！', type: 'error'});
          } else {
            this.$notify({
              type: "error",
              title: '保存操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: '保存失败！', type: 'error'});
          }
        }
      })
        .catch(err => {
          console.log(err);
          this.$message({message: '请求失败！', type: 'error'});
          this.loading = false;
        }).finally(() => {
        loading.close()
      })
    },

    wholesaleOrderNoChange(item) {
      let data = this.$refs.listOperationForm.formModel;
      data.wholesaleCustomerId = item.wholesaleCustomerId;
      data.wholesaleStoreId = item.wholesaleStoreId;
      data.relateId = item.id;
      data.warehouseId = item.warehouseId;
      data.wholesaleOrderNo = item.orderNo;
      this.isSelectWarehouse = false;
      this.$refs['listOperation'].clearTableData();
      this.loading = true;
      this.$axios.fetchPost(api.wholesale.salesGoods + '/list', {wholesaleOrderNo: data.wholesaleOrderNo}).then(goodsData => {
        this.loading = false;
        this.goodsCopyList = goodsData.data;
        goodsData.data.map(item => {
          item.id = item.goodsId
          item.name = item.goodsName;
          item.tradePrice = item.beforePrince;
        });
        this.$refs['listOperation'].addMoreRow(goodsData.data, 0);
      })
    },
    // 选择批发客户
    customerChange(data) {
      let editCustomer = this.listFormOptions.columns.filter(item => item.prop === 'wholesaleCustomerId')[0].isEditedCustomer;
      if (editCustomer === false) {
        this.getSalesOrder(data);
      } else {
        this.listFormOptions.columns.filter(item => item.prop === 'wholesaleCustomerId')[0].isEditedCustomer = false;
      }
    },
    getSalesOrder(form) {
      this.$axios.fetchPost(api.wholesale.salesCompleteBills + '/list', {
        wholesaleCustomerId: form.wholesaleCustomerId,
        warehouseId: form.warehouseId
      }).then(data => {
        if (data.code === 200) {
          this.listFormOptions.columns.filter(item => item.prop === 'wholesaleOrderNo')[0].data = data.data;
        }
      });
      if (!this.$route.query.id) {
        this.$refs['listOperation'].clearTableData();
        this.$refs.listOperationForm.formModel.orderNo = '';
        // this.$refs.listOperationForm.formModel.warehouseId = "";
        // this.$refs.listOperationForm.formModel.salesman = "";
        this.$refs.listOperationForm.formModel.wholesaleOrderNo = '';
        // this.$refs.listOperationForm.formModel.remarks = "";
      }
    },
    // 选择仓库
    warehouseChange(data) {
      if (this.isClearTableData) {
        this.$refs['listOperation'].clearTableData();
        this.$refs.listOperationForm.formModel.wholesaleOrderNo = '';
        this.getSalesOrder(data);
      } else {
        this.isClearTableData = true;
      }
      this.otherParam.warehouseId = data.warehouseId;
      this.isSelectWarehouse = false;
    },
    downloadTemplate() {
      if (!this.isCheck) {
        this.$axios.fetchPost(api.wholesale.wholesaleTemplateExport + '?&downType=10').then(data => {
          if (data.code === 200) {
            const elink = document.createElement('a');
            elink.href = data.data;
            elink.click();
            this.loadingExt = false;
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '导出成功', type: 'success'});
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: '导出异常', type: 'error'});
          }
        })
      }
    },
    // 导入数据
    importData() {
      if (!this.isCheck) {
        let tableData = this.$refs.listOperationForm.formModel;
        if (tableData.warehouseId) {
          this.$utils.uploadFile((file) => {
            // this.loading = true;
            let formData = new FormData();
            formData.append('multipartFile', file);
            formData.append('warehouseId', tableData.warehouseId);
            formData.append('businessType', 20);
            this.$refs['listOperation'].clearTableData();
            const loading = this.$loading({
              lock: true,
              text: '提交中，请稍候...',
              background: 'rgba(225, 225, 225, 0.8)'
            });
            this.$axios
              .fetchPostGoodsExport(api.wholesale.wholesaleImportGoods, formData)
              .then(data => {
                if (data.code === 200) {
                  this.importShow = false;
                  // 为表格赋值
                  if (data.data.wlWholesaleOrderGoodsMapMVOList) {
                    data.data.wlWholesaleOrderGoodsMapMVOList.map(item => {
                      item.id = item.goodsId;
                      item.name = item.goodsName;
                      item.beforeAmt = (item.tradePrice * item.goodsCount).toFixed(2);
                      if (item.discountRate) {
                        item.discountPrince = (item.tradePrice * item.discountRate).toFixed(2);
                        item.discountAmt = (item.discountPrince * item.goodsCount).toFixed(2)
                      } else {
                        item.discountRate = '1.00';
                        item.discountPrince = item.tradePrice;
                        item.discountAmt = item.beforeAmt;
                      }
                    });
                    this.$refs['listOperation'].addMoreRow(data.data.wlWholesaleOrderGoodsMapMVOList, 0);
                  }
                  if (data.data.errorBatchId) {
                    this.exportErrorData(data.data.errorBatchId);
                  }
                } else {
                  if (data.errorMsg) {
                    this.$message({message: data.errorMsg, type: 'error'});
                  } else {
                    this.$notify({
                      type: "error",
                      title: '导入操作',
                      message: '失败',
                      showClose: false,
                    });
                    // this.$message({message: '导入异常', type: 'error'});
                  }
                }
              })
              .catch((err) => {
                this.loading = false;
                console.log(err);
              }).finally(() => {
              loading.close()
            })
          });
        } else {
          this.$message({message: '请选择仓库！', type: 'warning'});
        }
      }
    },
    // 导入的错误数据
    exportErrorData(id) {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      this.$axios.PostBlob(api.system.exportError + '?batchId=' + id, '').then(res => {
        if (res.status === 200) {
          const fileName = '批发退货错误数据' + '_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          // this.$message.success("导出成功,文件名称:" + fileName);
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
    discountPrinceChange(row, index) {
      let rowData = this.$utils.deepClone(this.currentTableList[index]);
      if (row.discountPrince === '' || row.discountPrince == null) {
        row.discountPrince = rowData.discountPrince.toString();
        return;
      }
      // 折扣价格修改后修改折扣率
      row.discountRate = (row.discountPrince / row.tradePrice).toFixed(2);
      if (row.goodsCount) {
        row.discountAmt = parseFloat(row.discountPrince * row.goodsCount).toFixed(2);
      }
      this.$refs['listOperation'].setCountData(row, index);
    },
    giveGoodsCountChange(row, index) {
      let rowData = this.$utils.deepClone(this.currentTableList[index]);
      if (row.giveGoodsCount === '' || row.giveGoodsCount == null) {
        row.giveGoodsCount = rowData.giveGoodsCount;
      }
    },
    // 选择批发门店
    storeChange(row) {
      this.otherParam.storeId = row.storeId
      this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: row.storeId}).then(data => {
        if (data.code === 200) {
          row.warehouseId = '';
          this.listFormOptions.columns.filter(item => item.prop === 'warehouseId')[0].data = data.data;
          if (data.data) {
            data.data.map(item => {
              if (item.defaultState === true) {
                row.warehouseId = item.id;
                this.isSelectWarehouse = false;
                this.otherParam.warehouseId = item.id;
              }
            })
          }
        } else {
          this.$message({message: '获取仓库失败!', type: 'error'});
        }
      });
      this.$nextTick(() => {
        // let list = this.listFormOptions.columns.filter(item => item.prop === 'wholesaleOrderNo')[0].data;
        // if (list) {
        if (!this.$route.query.id) {
          this.$refs['listOperation'].clearTableData();
          this.$refs.listOperationForm.formModel.orderNo = '';
          this.$refs.listOperationForm.formModel.wholesaleOrderNo = '';
          this.$refs.listOperationForm.formModel.wholesaleCustomerId = '';
          this.listFormOptions.columns.filter(item => item.prop === 'wholesaleOrderNo')[0].data = [];
        }
        // }
      });
    },
    openImport() {
      if (!this.isCheck) {
        let tableData = this.$refs.listOperationForm.formModel;
        if (tableData.warehouseId) {
          this.importShow = true;
        } else {
          this.$message.warning("请选择仓库")
        }
      }
    },
  }
}
</script>
<style scoped>
>>> .el-dialog__header {
  margin-bottom: 5px;
}

.order-add-page .search-goods-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.order-add-page .search-goods-box .select-good {
  margin-left: 16px;
}

.search-goods-input {
  width: 300px;
}

/deep/ #goodsText {
  height: 32px;
}

/deep/ .importDialog {
  width: 640px;
  min-width: 640px;
}
</style>



// WEBPACK FOOTER //
// src/page/wholeasle/ReturnAdd.vue